import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "sidebar",
    "backdrop",
    "main",
    "brandText",
    "linkText",
    "subNav",
    "collapseIcon",
  ];

  connect() {
    const saved = localStorage.getItem("sidebarCollapsed");
    this.collapsed = saved === "true";
    this.mobileOpen = false;
    this.applyState();
  }

  toggle() {
    this.collapsed = !this.collapsed;
    localStorage.setItem("sidebarCollapsed", this.collapsed);
    this.applyState();
  }

  openMobile() {
    this.mobileOpen = true;
    this.sidebarTarget.classList.remove("-translate-x-full");
    this.backdropTarget.classList.remove("hidden");
  }

  closeMobile() {
    this.mobileOpen = false;
    this.sidebarTarget.classList.add("-translate-x-full");
    this.backdropTarget.classList.add("hidden");
  }

  closeMobileOnEscape(event) {
    if (event.key === "Escape" && this.mobileOpen) {
      this.closeMobile();
    }
  }

  applyState() {
    if (this.collapsed) {
      this.sidebarTarget.classList.remove("lg:w-64");
      this.sidebarTarget.classList.add("lg:w-16");
      this.mainTarget.classList.remove("lg:ml-64");
      this.mainTarget.classList.add("lg:ml-16");

      this.linkTextTargets.forEach((el) => el.classList.add("lg:hidden"));
      this.brandTextTarget.classList.add("lg:hidden");
      if (this.hasSubNavTarget) {
        this.subNavTarget.classList.add("lg:hidden");
      }
      this.collapseIconTarget.classList.add("rotate-180");
    } else {
      this.sidebarTarget.classList.remove("lg:w-16");
      this.sidebarTarget.classList.add("lg:w-64");
      this.mainTarget.classList.remove("lg:ml-16");
      this.mainTarget.classList.add("lg:ml-64");

      this.linkTextTargets.forEach((el) => el.classList.remove("lg:hidden"));
      this.brandTextTarget.classList.remove("lg:hidden");
      if (this.hasSubNavTarget) {
        this.subNavTarget.classList.remove("lg:hidden");
      }
      this.collapseIconTarget.classList.remove("rotate-180");
    }
  }
}
